var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "#b3ccdb",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-icon",
    transform: "translate(-5787 4193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 16,
    height: 16,
    transform: "translate(5787 -4193)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(4870 -4373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_50",
    "data-name": "Line 50",
    d: "M10,11.5a1.5,1.5,0,0,1-1.061-.439l-10-10a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.121,0l10,10A1.5,1.5,0,0,1,10,11.5Z",
    transform: "translate(920 183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_51",
    "data-name": "Line 51",
    d: "M10,11.5a1.5,1.5,0,0,1-1.061-.439l-10-10a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.121,0l10,10A1.5,1.5,0,0,1,10,11.5Z",
    transform: "translate(930 183) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.80706488.svg";
export { ForwardRef as ReactComponent };